import type { FaireProductEntity } from "../../entity_types/product";

export const p_5txjbe8ff5: FaireProductEntity = {
  token: "p_5txjbe8ff5",
  type: "product",
  name: "Cheese Snob Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/e45eb717cc207979886b83a20a6df1c9003c8a723e6bc4eaf1f5b41fbe881cd3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1e4832ca35149614927741fe18d63ca1267dadd3a2a4f33556b048e7445b8cdc.jpeg",
    "https://cdn.faire.com/fastly/6cbfdda72fa0960ecda8a0778872a77e60f7b99b52612f6ab41b5e35cd1d26dd.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/e9d5cafb735176b4d24d5e78235107fc7859c35294c6cc21bc156ec377becd67.jpeg",
    "https://cdn.faire.com/fastly/c51380e74946f2d00ac9e7dc2ca5b0701827faea829e8bccf9c0fcbe175c8f4d.jpeg"
  ],
  priceDollars: 6.75,
  description: "Socks for people who love to pair cheese with their opinions... and both are strong.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:56.921Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
